module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/may/mainvisual-bg-pc_31d6da83b212b357d89f4e350da58d13.png";